export enum peronItemModes {
  personMode = 1,
  ownerMode = 2,
  nameMode = 3,
}
